<template>
  <v-card>
    <v-card-title>Quick Actions</v-card-title>
    <v-card-text>
      <div class="actions-list">
        <router-link to="/requests" class="action-button">
          <span class="action-icon">📋</span>
          <div>
            <div class="action-title">View Requests</div>
            <div class="action-desc">Manage equipment requests</div>
          </div>
        </router-link>

        <router-link to="/inventory" class="action-button">
          <span class="action-icon">💻</span>
          <div>
            <div class="action-title">Manage Inventory</div>
            <div class="action-desc">Add and track equipment</div>
          </div>
        </router-link>

        <button @click="$emit('refresh')" class="action-button">
          <span class="action-icon">🔄</span>
          <div>
            <div class="action-title">Refresh Data</div>
            <div class="action-desc">Update dashboard stats</div>
          </div>
        </button>
      </div>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
/* eslint-disable no-undef */
defineEmits(['refresh'])
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&family=Inter:wght@400;500;600&display=swap');

.actions-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.action-button {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: var(--light-bg, #f5f7fa);
  border: 2px solid transparent;
  border-radius: 8px;
  text-decoration: none;
  color: var(--text-dark, #333333);
  cursor: pointer;
  transition: all 0.3s;
  width: 100%;
  text-align: left;
}

.action-button:hover {
  background: var(--white, #ffffff);
  border-color: var(--secondary-color, #3ba3d1);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 163, 209, 0.2);
}

.action-icon {
  font-size: 2rem;
}

.action-title {
  font-weight: 600;
  color: var(--primary-color, #2c4a6b);
  margin-bottom: 0.25rem;
}

.action-desc {
  font-size: 0.9rem;
  color: var(--text-light, #666666);
}
</style>
